import React from 'react';
import Btn, { ButtonRefType } from '../Btn';
import { BtnModifier } from '../Btn';
import { TooltipPlacement } from '../../../atoms/Tooltip';
import { SharedButtonProps } from './SharedButtonProps';

type ButtonToggleSpecificProps = {
  text?: string;
  active?: boolean;
  disabledLink?: boolean;
  type?: 'button' | 'submit' | 'reset';
  formAction?: string;
  focusOnMount?: boolean;
  reference?: ButtonRefType;
  href?: string;
  routing?: boolean;
  tooltipPlacement?: TooltipPlacement;
  children?: React.ReactNode;
};

export type ButtonToggleProps = SharedButtonProps & ButtonToggleSpecificProps;

export function ButtonToggle({
  text,
  active = false,
  disabledLink = false,
  type = 'button',
  ariaLabel,
  ariaDescribedBy,
  formAction,
  focusOnMount,
  reference,
  href,
  routing,
  tooltipPlacement,
  onClick,
  onKeyDown,
  onKeyUp,
  ariaControls,
  ariaCurrent,
  ariaPressed,
  ariaExpanded,
  children,
  ...rest
}: ButtonToggleProps) {
  const modifier = active ? [BtnModifier.TOGGLE, BtnModifier.ACTIVE] : [BtnModifier.TOGGLE];

  return (
    <Btn
      {...rest}
      modifier={modifier}
      text={text}
      disabledLink={disabledLink}
      onClick={onClick}
      onKeyDown={onKeyDown}
      onKeyUp={onKeyUp}
      ariaControls={ariaControls}
      ariaCurrent={ariaCurrent}
      ariaPressed={ariaPressed}
      ariaExpanded={ariaExpanded}
      type={type}
      ariaLabel={ariaLabel}
      ariaDescribedBy={ariaDescribedBy}
      formAction={formAction}
      focusOnMount={focusOnMount}
      reference={reference}
      href={href}
      routing={routing}
      tooltipPlacement={tooltipPlacement}
    >
      {children}
    </Btn>
  );
}
